<template>
  <div
    class="d-flex pa-2 flex-column mt-12"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <v-card class="mb-12" height="20px" :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Detail History Insert Transaction On Us</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">

      <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> NMID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.nmid }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> MID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mid_bank }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> RRN </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.rrn }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Metode </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.payment_channel }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> MPAN </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mpan }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Trx Date </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.trx_date }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Trx Time </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.trx_time }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Trx Amount </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.amount }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Log Request Payment Credit </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7" class="text-body-2">
            {{ data == null ? '' : data.log_request }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Request By </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_request_by_name }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Request Date Time </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_request_date }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Approval Status </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_status }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Remarks </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_remark }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Approved by </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_approve_by_name }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Approve Date </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_approve_date }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Approval Status </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_status }}
          </v-col>
        </v-row>


        <!-- Checkbox Confirmation -->
        <v-row>
          <v-card-text>
            <div class="d-flex align-start mt-12">
              <v-checkbox
              disabled
                v-model="confirmationChecked"
                color="primary"
              />
              <span>{{ confirmationText }}</span>
            </div>
          </v-card-text>
        </v-row>

        <!-- Action Buttons -->
        <v-row class="d-flex justify-space-between mt-16 mb-8">
          <!-- Back Button -->
          <v-btn @click="goBack" color="secondary">
            <v-icon>mdi-arrow-left</v-icon>
            Kembali
          </v-btn>
        </v-row>
      </div>
    </v-card>

  </div>
</template>
<script>
import { date } from '../../lib/helpers';

export default {
  data() {
    return {
      confirmationChecked: true,
      confirmationText: `Saya telah memeriksa ulang pengajuan dan saya telah membaca, memahami, dan menyetujui seluruh syarat dan ketentuan yang berlaku terkait dengan proses insert transaction off us.  Saya juga memahami bahwa dengan memberikan konfirmasi ini,
      saya mengizinkan untuk memproses insert transaction off us atas transaksi tersebut sesuai dengan prosedur yang telah ditetapkan.
      Saya bertanggung jawab penuh atas kebenaran data yang saya setujui dan konsekuensi dari setiap kesalahan data tersebut. Saya juga memahami bahwa konfirmasi ini tidak dapat dibatalkan ketika approval transaction off us dilakukan.*`
    };
  },
  computed : {
    data() {
      return this.$store.state.historyTransactionOnUs.dataDetail;
    },

    loading() {
      return this.$store.state.historyTransactionOnUs.loading;
    },
  },

  methods: {
    async getDetail() {
      this.loading = true;
      await this.$store.dispatch('historyTransactionOnUs/getDetail',  { date, id: this.$route.params.id });
      this.loading = false;
    },
    goBack() {
      this.$router.push('/insert-transaction-on-us/history-insert-transaction');
    },
  },
  mounted() {
    this.getDetail();
  }
};
</script>

<style>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>